const colorClasses = {
  blue: 'text-blue-400',
  green: 'text-green-400',
  amber: 'text-amber-400',
  red: 'text-red-400',
  purple: 'text-purple-400',
};

export default function StatCard({ value, label, color = 'blue' }) {
  const valueColor = colorClasses[color] || colorClasses.blue;

  return (
    <div className="bg-[#12141e] border border-[#1e2235] rounded-lg p-4">
      <p className={`text-2xl font-bold ${valueColor}`}>{value}</p>
      <p className="text-gray-400 text-sm mt-2">{label}</p>
    </div>
  );
}
